import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { api } from "../../../api";
import { toast } from "react-toastify";
import Loader from "../../loader/Loader";
import Button from "../../button";
import { decimalTo } from "../../../utils/utils";

export default function Details() {
  const token = useSelector((state) => state.auth.token);
  const region = useSelector((state) => state.auth.region);
  const commentRef = useRef(null);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line
  const [order, setOrder] = useState([]);
  // eslint-disable-next-line
  const [orderId, setOrderId] = useState(useParams().id);
  const [cartData, setCartData] = useState("");
  const [button, setButton] = useState(false);
  const processingToastId = useRef(null);
  const processingIntervalRef = useRef(null);

  const processingMessages = [
    "Please wait, we are processing your order...",
    "Fetching your product keys...",
    "Almost there, hang tight...",
    "Finalizing your order...",
  ];

  function startProcessingMessages() {
    let index = 0;
    processingToastId.current = toast.info(processingMessages[index], {
      autoClose: false,
      closeOnClick: false,
      closeButton: false,
      draggable: false,
    });
    processingIntervalRef.current = setInterval(() => {
      index = (index + 1) % processingMessages.length;
      toast.update(processingToastId.current, {
        render: processingMessages[index],
      });
    }, 4000);
  }

  function stopProcessingMessages() {
    clearInterval(processingIntervalRef.current);
    toast.dismiss(processingToastId.current);
  }

  const isDevco = cartData[0]?.isDevco || false;
  const isEpay = cartData[0]?.isEpay || false;

  useEffect(() => {
    api.orders.getCarts({}, token).then((result) => {
      if (result.success === true) {
        console.log("cartData[0]:", result.data[0]);
        setCartData(result.data);
      } else {
        toast.error(result.message);
      }
    });
  }, [token]);

  function convertExponentialToDecimal(exponentialNumber) {
    const str = exponentialNumber.toString();
    const strVal = str.split(/[eE]/);
    if (strVal.length > 0) {
      return decimalTo(strVal[0]).toFixed(2);
    }
  }

  function getTotalAmount() {
    var msgTotal = cartData.reduce(function (prev, cur) {
      return prev + cur.productAmount;
    }, 0);
    return convertExponentialToDecimal(msgTotal && msgTotal);
  }

  function handleRemoveFromCart(event, id) {
    api.orders
      .deleteCart({ delete_array: [id] }, token)
      .then((res) => {
        if (res.success === true) {
          api.orders.getCarts({}, token).then((result) => {
            if (result.success === true) {
              setCartData(result.data);
              toast.success(res.message);
            } else {
              toast.success(res.message);
              toast.error(result.message);
              navigate("/orders");
            }
          });
        }
      })
      .catch((err) => console.log(err));
  }

  function handlePlaceOrder() {
    setButton(true);
    const body = {
      orderAddress: cartData[0].merchentAddress,
      comment: commentRef?.current || "",
    };

    setLoading(true);
    startProcessingMessages();
    api.orders.create(body, token).then((result) => {
      stopProcessingMessages();
      if (result.success === true) {
        toast.success(result.message);
        navigate("/orders");
      } else {
        toast.error(result.message);
      }
      setLoading(false);
      setButton(false);
    });
  }

  function handlePlaceEpayOrder() {
    setButton(true);
    const body = {
      orderAddress: cartData[0].merchentAddress,
      comment: commentRef?.current || "",
    };

    setLoading(true);
    startProcessingMessages();
    api.orders.epayOrder(body, token).then((result) => {
      stopProcessingMessages();
      if (result.success === true) {
        toast.success(result.message);
        navigate("/orders");
      } else {
        toast.error(result.message);
      }
      setLoading(false);
      setButton(false);
    });
  }

  function handlePlaceDevcoOrder() {
    setButton(true);
    const body = {
      orderAddress: cartData[0].merchentAddress,
      comment: commentRef?.current || "",
    };

    setLoading(true);
    startProcessingMessages();
    api.orders.devcoOrder(body, token).then((result) => {
      stopProcessingMessages();
      console.log(result);
      if (result.success === true) {
        toast.success(result.message);
        navigate("/orders");
      } else {
        toast.error(result.message);
      }
      setLoading(false);
      setButton(false);
    });
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12">
          <div className="box-row">
            <div className="table-head">
              <h1 className="sec-header">ORDER DETAILS</h1>
            </div>
            <div className="card card-table">
              <div className="card-header card-header-title">
                {/* <p>Order Details</p>
                                <div className="detail-id float-left mt-4">Order ID : <b>{orderId}</b></div> */}
              </div>
              {/* <hr /> */}
              <div className="row">
                {/* <div className="col-md-6">
                                    <div className="billing text-left ml-4">
                                        <h3>Billing To:</h3>
                                        <p>Flipkart <br />John Doe <br />(536) 512 6523 <br />johndoe@gmail.com</p>
                                        <h3 className="mt-4">Payment Method:</h3>
                                        <p>Visa ending **** 4242</p>
                                    </div>

                                </div> */}
                {/* <div className="col-md-6">
                                    <div className="billing mr-4 text-right">
                                        <h3>Order Date</h3>
                                        <p>October 16, 2019</p>
                                        <h3>Payment Status:</h3>
                                        <p>Pending</p>

                                        <Link to="/view-orders" className="btn mt-3 submit-btn">Reprocess</Link>
                                    </div>
                                </div> */}
              </div>

              <div className="card-body gatepass-saveoutput">
                <div className="reports order-summary">
                  <h3 className="mt-3">Cart Summary</h3>

                  <div
                    style={{ position: "absolute", top: "0px", right: "15px" }}
                  >
                    {/* <Link to="/add-orders">
                      <button
                        className="btn mt-3 submit-btn"
                        variant="primary"
                        type="submit"
                      >
                        {" "}
                        Continue Order
                      </button>
                    </Link> */}
                  </div>

                  <table
                    id="product-table"
                    className="table table-responsive mt-4"
                  >
                    <thead>
                      <tr>
                        <th>No.</th>
                        <th>Items</th>
                        <th>Quantity</th>
                        <th>Margin</th>
                        <th>
                          {region.currency
                            ? `Total Price (${region.currency})`
                            : "Total Price"}
                        </th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cartData.length > 0 ? (
                        <React.Fragment>
                          {cartData.map((row, index) => (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{row.product}</td>
                              <td>{parseInt(row.quantity)}</td>
                              <td>{decimalTo(row.margin).toFixed(2)}</td>
                              <td>
                                {row.productAmount &&
                                  decimalTo(row.productAmount).toFixed(2)}
                              </td>
                              <td>
                                <button
                                  type="button"
                                  className="view-btn"
                                  onClick={(event) =>
                                    handleRemoveFromCart(event, row.cartId)
                                  }
                                  disabled={loading}
                                  style={{ border: 0, backgroundColor: "#fff" }}
                                >
                                  <i className="bx bx-x-circle font-size"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </React.Fragment>
                      ) : null}
                    </tbody>
                  </table>
                  {/* 

                                    {cartData.length > 0 ?
                                        <div> <div className="row table-total">


                                            <div className="col-md-2 col-sm-6 col-xs-12 float-right text-right total-ans">
                                                <button type="submit" className="btn mt-3 submit-btn float-right" onClick={handlePlaceOrder} disabled={button}>Place Order</button>


                                            </div>

                                        </div></div>


                                        : null} */}

                  {cartData.length > 0 ? (
                    <div className="float-right text-right ml-4 mr-4">
                      <div className="row table-total">
                        <div className="float-right text-left total-ans pr-2">
                          <h6>
                            <b>Total Price:</b>
                          </h6>
                        </div>
                        <div>
                          <h6>
                            <b>{getTotalAmount()}</b>
                          </h6>
                        </div>
                      </div>
                      <div className="row table-total">
                        <Button
                          loading={button}
                          disabled={button}
                          buttonName="Place Order"
                          onClick={
                            isDevco
                              ? handlePlaceDevcoOrder
                              : isEpay
                              ? handlePlaceEpayOrder
                              : handlePlaceOrder
                          }
                        >
                          <Loader />
                        </Button>
                      </div>
                    </div>
                  ) : null}
                  <div className="float-left text-left col-md-6">
                    <label htmlFor="">Comment</label>
                    <textarea
                      name="comment"
                      id="comment"
                      onChange={(e) => (commentRef.current = e.target.value)}
                      className="w-100"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
